import {
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';
import { requestHtml } from '@vfde-sails/utils';
import { TRIGGERNEXTOVERLAY } from 'Constant';

import {
    getOverlayContentFailed,
} from './action';
import {showOverlay} from './components/Overlay';
import { AnyAction } from 'redux';

/**
 * Gets the content of the overlay and populates it
 *
 * @export {function} getOverlayContent
 *
 */
export function* getOverlayContent (action) {
    const {url} = action;

    try {
        const response = yield call(requestHtml, url, {});
        yield call(showOverlay, response);

    } catch (err) {
        yield put(getOverlayContentFailed(err));
    }
}

/**
 * Waits for TRIGGERNEXTOVERLAY action from core to call getAPI
 *
 * @export {function} overlaySaga
 *
 */
export default function* overlaySaga () {
    yield takeLatest(TRIGGERNEXTOVERLAY, getOverlayContent);
}
